import React, { useEffect } from 'react';
import { Box, Typography, Button, Card, CardContent } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../component/ui/FormFields/Button';
import {
  addRoleRequest,
  resetRoleState,
} from '../../redux/Roles/actions/RolesActions';
import { ROLES } from '../../component/common/Routes/AppRoutes';
import TextInputField from '../../component/ui/FormFields/TextInputField';
import PermissionsTable from '../../component/ui/PermissionsTable';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const permissionsTemplate = {
  add: false,
  view: false,
  edit: false,
  delete: false,
  allaccess: false,
  noaccess: false,
};

const permissionsData = {
  staffs: { ...permissionsTemplate },
  airports: { ...permissionsTemplate },
  services: { ...permissionsTemplate },
  bookings: { ...permissionsTemplate },
  billingPayment: { ...permissionsTemplate },
  billingPackage: { ...permissionsTemplate },
};

const PermissionsForm = () => {
  const {
    control,
    handleSubmit,
    setValue,
    register,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      roleName: '',
      permissions: permissionsData,
    },
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, success, error } = useSelector((state) => {
    return state.roles;
  });

  const handlePermissionChange = (category, perm, checked) => {
    const permissionsList = [
      'add',
      'view',
      'edit',
      'delete',
      'allaccess',
      'noaccess',
    ];

    if (perm === 'allaccess') {
      permissionsList.forEach((key) => {
        if (key !== 'allaccess' && key !== 'noaccess') {
          setValue(`permissions.${category}.${key}`, checked);
        }
      });
      setValue(`permissions.${category}.noaccess`, false);
      setValue(`permissions.${category}.allaccess`, checked);
    } else if (perm === 'noaccess') {
      permissionsList.forEach((key) => {
        if (key !== 'noaccess') {
          setValue(`permissions.${category}.${key}`, false);
        }
      });
      setValue(`permissions.${category}.noaccess`, checked);
    } else {
      setValue(`permissions.${category}.${perm}`, checked);
      if (checked) {
        setValue(`permissions.${category}.noaccess`, false);
      }
    }

    const currentPermissions = getValues(`permissions.${category}`);
    const allChecked = permissionsList
      .slice(0, 4)
      .every((key) => currentPermissions[key]);
    setValue(`permissions.${category}.allaccess`, allChecked);
  };

  const onSubmit = (data) => {
    const payload = [
      {
        name: data.roleName,
        status: '0',
        permissions: JSON.stringify(data.permissions),
      },
    ];

    dispatch(addRoleRequest(payload));
  };

  useEffect(() => {
    if (success) {
      toast.success('Role Inserted Successfully', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetRoleState());
          navigate(ROLES); // Navigate after the toast is closed
        },
      });
    }
  }, [success]);
  useEffect(() => {
    if (error) {
      toast.error(error, {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetRoleState());
        },
      });
    }
  }, [error]);

  return (
    <>
      <ToastContainer />
      <Box className='role-permission-container'>
        <Card>
          <CardContent className='card'>
            <Typography variant='h5' gutterBottom className='form-heading'>
              Add Role
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Box className='role-permission-input-container'>
                <Controller
                  name='roleName'
                  control={control}
                  rules={{ required: 'Role Name is required' }}
                  render={({ field }) => (
                    <TextInputField
                      label='Role Name *'
                      fullWidth
                      placeholder='Enter role name'
                      error={!!errors.roleName}
                      helperText={errors.roleName?.message}
                      {...field}
                    />
                  )}
                />
              </Box>

              <PermissionsTable
                control={control}
                permissionsData={permissionsData}
                handlePermissionChange={handlePermissionChange}
              />

              <Box className='role-permission-button-container'>
                <Button
                  variant='contained'
                  color='error'
                  onClick={() => navigate(ROLES)}
                  className='cancel-button'
                >
                  Cancel
                </Button>

                <CustomButton
                  variant='contained'
                  className='success-button'
                  type='submit'
                  loading={loading}
                  text={'submit'}
                />
                {/* <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  disabled={loading}
                  className='success-button'
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </Button> */}
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default PermissionsForm;
